export const CONFIRM_AND_ASSIGN = "CONFIRM_AND_ASSIGN";
export const CONFIRM_AND_ASSIGN_RESPONSE = "CONFIRM_AND_ASSIGN_RESPONSE";
export const RESET_CONFIRM_AND_ASSIGN_RESPONSE = "RESET_CONFIRM_AND_ASSIGN_RESPONSE";